import React from 'react';
import {
  Snackbar,
  Alert,
  Box,
  Button,
  Typography,
} from '@mui/material';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';

interface ResponseNotificationSnackbarProps {
  open: boolean;
  notificationMessage: string;
  onView: () => void;
  onDismiss: () => void;
}

const ResponseNotificationSnackbar: React.FC<ResponseNotificationSnackbarProps> = ({
  open,
  notificationMessage,
  onView,
  onDismiss,
}) => {
  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      sx={{
        top: '40px !important',
        right: '24px !important',
      }}
    >
      <Alert
        severity="info"
        icon={<NotificationsActiveIcon />}
        sx={{
          minWidth: '300px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          '& .MuiAlert-message': {
            width: '100%',
          },
        }}
        action={
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              size="small"
              variant="contained"
              onClick={onView}
              sx={{
                textTransform: 'none',
                bgcolor: '#667eea',
                fontSize: 12,
                '&:hover': { bgcolor: '#5568d3' },
              }}
            >
              View
            </Button>
            <Button
              size="small"
              onClick={onDismiss}
              sx={{ textTransform: 'none', fontSize: 12 }}
            >
              Dismiss
            </Button>
          </Box>
        }
      >
        <Typography variant="body2" fontWeight={600}>
          Response received in another chat
        </Typography>
        <Typography variant="caption" sx={{ display: 'block', mt: 0.5 }}>
          {notificationMessage.length > 50
            ? notificationMessage.substring(0, 50) + '...'
            : notificationMessage}
        </Typography>
      </Alert>
    </Snackbar>
  );
};

export default ResponseNotificationSnackbar;